<template>
  <div class="nav">
    <nav>
      <div id="left">
        <img src="@/assets/logo.svg" alt="TrakYak Logo, a cool yak!" />
        <router-link to="/">TrakYak</router-link>
      </div>
      <div id="right">
        <a href="/#features">Features</a>
        <a href="/#pricing">Pricing</a>
        <router-link to="/login">Login</router-link>
        <router-link to="/signup">Sign Up</router-link>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar"
};
</script>

<style lang="scss" scoped>
.nav {
  color: #f7f9fb;
  background: #0cce6b;
  padding: 15px 0;
  width: 100%;
  position: absolute;
  top: 0;

  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1198px;
  }

  #left {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      font-size: 2.125rem;
      font-weight: 600;
    }
  }

  a {
    color: #f7f9fb;
    margin: 0 20px;
    text-decoration: none;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>